import {createContext, useState, useContext} from 'react';
import clsx from "clsx";

export const useAlert = () => useContext(AlertContext);

const ALERT_TIME = 5000;

const initialState = {
  text: '',
  type: '',
};

const AlertContext = createContext({
  ...initialState,
  setAlert: (text: string, type: string) => {},
});

export const AlertProvider = ({ children }: any) => {
  const [text, setText] = useState('');
  const [type, setType] = useState('');

  const setAlert = (text: string, type: string) => {
    setText(text);
    setType(type);

    setTimeout(() => {
      setText('');
      setType('');
    }, ALERT_TIME);
  };

  return (
    <AlertContext.Provider
      value={{
        text,
        type,
        setAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

const AlertPopup = () => {
  const { text, type }: { text: string, type: string } = useAlert();

  const alertConfig: {[key: string]: string} = {
    success: 'border-emerald-900 bg-emerald-100 text-emerald-900',
    error: 'border-rose-900 bg-rose-100 text-rose-900',
  }

  if (text && type) {
    return (
      <div className={
        clsx(
          "inline-block text-sm fixed top-5 z-50 border left-1/2 -translate-x-1/2 py-2.5 px-5 rounded-lg",
          alertConfig[type]
        )
      }>
        {text}
      </div>
    );
  } else {
    return <></>;
  }
};

export default AlertPopup;
